module.exports = "<div class=\"select category\">\n\t<h5>Select a Device Category</h5>\n\t<!-- <prg-list-selector [listSource]=\"(categories | async)\" displayField=\"label\" (selected)=\"categorySelected($event)\"></prg-list-selector> -->\n\t<prg-grid-selector [items]=\"(categories | async)\" (selected)=\"categorySelected($event)\"></prg-grid-selector>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-category/select-category.component.html
// module id = 1519
// module chunks = 2